import React, {FC} from "react";
import {Backdrop, CircularProgress} from "@material-ui/core";
import useStyles from "./styles";

type Props = {
  isLoading: boolean;
};

const BackdropLoader: FC<Props> = ({isLoading}) => {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={isLoading}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default BackdropLoader;
